import React from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { GiDeliveryDrone } from 'react-icons/gi';

import Icons from 'consts/icons';
import PopupLoader from 'components/common/PopupLoader';
import { setLanguage } from 'store/actions/language/language';
import { useLoginStyles } from 'consts/styles/Login';

import Copyright from './Copyright';
import SignIn from './SignIn';
import SetPassword from './SetPassword';
import PasswordReset from './PasswordReset';

const LoginPage = props => {
  const { history } = props;
  const [siteLang, setSiteLang] = React.useState('en');
  const [seeableLoader, setSeeableLoader] = React.useState(false);
  const [type, setType] = React.useState('login');

  const dispatch = useDispatch();

  const changeLanguage = () => {
    const langToShow = siteLang === 'pl' ? 'en' : 'pl';
    setSiteLang(langToShow);
    dispatch(setLanguage(langToShow));
  };

  const classes = useLoginStyles();

  const handleSwitch = () => {
    switch (type) {
      case 'login':
        return (
          <SignIn
            siteLang={siteLang}
            setSeeableLoader={setSeeableLoader}
            history={history}
            dispatch={dispatch}
            setType={setType}
          />
        );
      case 'reset':
        return (
          <PasswordReset
            siteLang={siteLang}
            history={history}
            dispatch={dispatch}
            setType={setType}
          />
        );
      case 'setpass':
        return (
          <SetPassword
            siteLang={siteLang}
            history={history}
            dispatch={dispatch}
            setType={setType}
          />
        );
      default:
        return 0;
    }
  };

  const init = () => {
    setType('login');
  };

  React.useEffect(init, []);

  return (
    <div className={classes.Login}>
      {seeableLoader && <PopupLoader />}

      {/* Animated background */}
      <div className={`${classes.Login}__bg-grid`} />
      <div className={`${classes.Login}__bg-radar`} />
      <div className={`${classes.Login}__bg-ring ${classes.Login}__bg-ring--1`} />
      <div className={`${classes.Login}__bg-ring ${classes.Login}__bg-ring--2`} />
      <div className={`${classes.Login}__bg-ring ${classes.Login}__bg-ring--3`} />
      <div className={`${classes.Login}__bg-ring ${classes.Login}__bg-ring--4`} />
      <div className={`${classes.Login}__bg-ring ${classes.Login}__bg-ring--5`} />
      <div className={`${classes.Login}__bg-ring ${classes.Login}__bg-ring--6`} />
      <div className={`${classes.Login}__bg-ring ${classes.Login}__bg-ring--7`} />
      <div className={`${classes.Login}__bg-scan`} />

      {/* Language switcher */}
      <Button
        className={`${classes.Login}__lang`}
        onClick={() => changeLanguage()}
      >
        <Icons.Misc.Language className={`${classes.Login}__lang__icon`} />
        <div className={`${classes.Login}__lang__text`}>
          {siteLang === 'pl' ? 'PL' : 'EN'}
        </div>
      </Button>

      {/* Branding */}
      <div className={`${classes.Login}__branding`}>
        <GiDeliveryDrone className={`${classes.Login}__branding__logo`} />
        <div className={`${classes.Login}__branding__title`}>ZODIAC</div>
        <div className={`${classes.Login}__branding__subtitle`}>
          Drone Traffic Management
        </div>
        <div className={`${classes.Login}__branding__divider`} />
      </div>

      {/* Login card */}
      <div className={`${classes.Login}__card-glow`} />
      <div className={`${classes.Login}__card`}>{handleSwitch()}</div>

      {/* Copyright */}
      <Box mt={4}>
        <Copyright />
      </Box>
    </div>
  );
};

LoginPage.propTypes = {
  history: PropTypes.object,
};

const mapStateToProps = state => ({
  language: state.language,
});

export default connect(mapStateToProps)(LoginPage);
